module.exports = __webpack_public_path__ + "front/img/p2.66dae795.jpg";